import React from "react";

export default function Slide() {
  return (
    <div className="swipervd">

      <video autoPlay loop playsInline muted className="video">
        <source src="img/videobg.mp4" />
      </video>

    </div>
  );
}
